import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { formatMoneyV2 } from '~/helpers'
import { useAppInfo } from '~/hooks/useAppInfo'

import { useRechargeForm } from '../../../../hooks/useRechargeForm'

const Alerts = () => {
  const {
    amountStepIsValid,
    paymentSectionIsValid,
    paymentRefused,
    debugMode,
    paymentMethod,
    cardStepIsValid
  } = useRechargeForm()

  const { rechargeMinValue } = useAppInfo()

  return (
    <section className="formRecharge__alerts d-flex flex-column gap-2">
      {!!paymentRefused && (
        <Alert variant="critical">{t('rm:payment.error.details')}</Alert>
      )}

      {!amountStepIsValid && (
        <Alert variant="warning">
          {t('rm:payment.warning.amount', {
            value: formatMoneyV2({ value: rechargeMinValue })
          })}
        </Alert>
      )}

      {!cardStepIsValid && (
        <Alert variant="warning">{t('rm:payment.warning.cardStep')}</Alert>
      )}

      {!paymentSectionIsValid && (
        <Alert variant="warning">
          {t('rm:payment.warning.paymentSection')}
        </Alert>
      )}

      {paymentMethod === 'marketplace' && (
        <>
          <Alert className="alertInfo" variant="informational">
            {t('rm:marketplace.payment.info1')}
          </Alert>
          <Alert className="alertInfo" variant="informational">
            {t('rm:marketplace.payment.info2')}
          </Alert>
        </>
      )}

      {debugMode && <Alert variant="warning">Debug submit</Alert>}
    </section>
  )
}

export default Alerts
